export const getBarParams = (num_compressors, pad_left, num_bars) => {
	/* 450 ist "fallbackProp" für VictoryChart width */
	let width = 450 - pad_left;
	let gap = 15;
	let num_gaps = num_compressors + 1;
	let per_compressor = (width - num_gaps * gap) / num_compressors;
	let bar_width = per_compressor/num_bars;
	let bar_offset = bar_width;
	let domain_padding = per_compressor/2 + gap;
	return {
		/* Die 14 ist ein Schummelfaktor ... weil es ansonsten bei
		 * num_compressors == 2 nicht gut aussieht
		 */
		bar_width, bar_offset,
		domain_padding: domain_padding + 14
	};
};

export const getBarParamsStateChanges = (num_compressors) => {
	const bar_width = 100 / num_compressors
	return {
		bar_width: bar_width,
		bar_offset: 0,
		domain_padding: bar_width
	}
}

export const formatSecondsAsDuration = (seconds, intl, max_parts = -1) => {
	// Erste Idee: "ab 12h soll 0.5d angezeigt werden"
	// -> schlechte Idee ... das führt bei Y-Labels zu wiederholten Werten, schlecht!
	// Zweite Idee: Anzeige 12h 30min 5s anzahl der Einträge steuerbar
	const scalings = [
		{ factor: 24 * 60 * 60, i18n_key: "d" },
		{ factor:      60 * 60, i18n_key: "h" },
		{ factor:           60, i18n_key: "min" },
		{ factor:            1, i18n_key: "s" }
	];
	if (max_parts < 0) {
		max_parts = scalings.length;
	}
	let handled_parts = 0;
	let formatted = "";
	for (let i = 0; i < scalings.length && handled_parts < max_parts; ++i) {
		let value = 0;
		if (seconds >= scalings[i].factor) {
			++handled_parts;
			while (seconds >= scalings[i].factor) {
				++value;
				seconds -= scalings[i].factor;
			}
		}
		// Nur ausgeben und als behandelten Teil berücksichtigen wenn
		// tatsächlich eine "Information" enthalten ist.
		// Eine Ausgabe von "12h 3s" ist möglich und (derzeit) erwünscht.
		// Wenn der Wert exakt 0 Sekunden beträgt, dann sollen die auch
		// so ausgegeben werden (ansonsten "").
		if (value > 0 || (formatted.length === 0 && i === scalings.length - 1)) {
			if (formatted.length) {
				formatted += " ";
			}
			formatted += value.toString() + intl.formatMessage({ id: scalings[i].i18n_key });
		}
	}
	return formatted;
};
